const labels = {
    PRODUCT_IMAGE_FALLBACK_URL: "https://http.cat/images/404.jpg",
    CARD_PHOTO_TYPE: "Royal_product_300",
    PLP_LOAD_MORE_DEFAULT: "Cargar más productos",
}

module.exports = { labels }
